import { apiGet } from '../../../utils/api';
import { config } from '../../../config/app-config';

const contentCache = new Map();

export function loadAllContent() {
  const contentElements = document.querySelectorAll('[data-content]');
  return loadContentForElements(contentElements);
}

export async function loadContentForElements(elements) {
  const promises = Array.from(elements).map(element => {
    const pageTitle = element.getAttribute('data-page') || 'Home';
    const tagId = element.getAttribute('data-content');
    const isGlobal = element.getAttribute('data-global') === 'true';
    return loadContentForElement(element, pageTitle, tagId, isGlobal);
  });

  return Promise.all(promises);
}

export async function loadContentForElement(element, pageTitle, tagId, isGlobal = false) {
  if (!tagId) return null;
  try {
    // For global content use special cache key
    const cacheKey = isGlobal ? `GLOBAL:${tagId}` : `${pageTitle}:${tagId}`;

    if (contentCache.has(cacheKey)) {
      return contentCache.get(cacheKey);
    }

    element.classList.add('content-loading');

    // For global content don't pass pageTitle
    const data = await fetchContent(isGlobal ? '' : pageTitle, tagId);

    element.classList.remove('content-loading');

    if (!data) {
      return null;
    }

    contentCache.set(cacheKey, data);
    return data;
  } catch (error) {
    console.error('Error loading content for', tagId, ':', error);
    element.classList.remove('content-loading');
    element.classList.add('content-error');
    return null;
  }
}

async function fetchContent(pageTitle, tagId) {
  try {
    // If pageTitle is empty, API should return global content
    const url = pageTitle
      ? `${config.api.paths.content}?page_title=${encodeURIComponent(pageTitle)}&tag_id=${encodeURIComponent(tagId)}`
      : `${config.api.paths.content}?page_title=&tag_id=${encodeURIComponent(tagId)}`;

    const data = await apiGet(url, { auth: false });
    return data;
  } catch (error) {
    console.error('API GET error:', error);
    throw error;
  }
}

export function clearContentCache(tagId) {
  // Clear cache for all variants of this tagId (including global)
  for (const key of contentCache.keys()) {
    if (key.includes(tagId)) {
      contentCache.delete(key);
    }
  }
}

export function getContentFromCache(key) {
  return contentCache.has(key) ? contentCache.get(key) : null;
}